/**
 * @module common/classes/app
 */

/**
 * @classdesc Класс приложения
 */
class App {
  constructor() {
    /**
     * @member {Set<module:common/classes/plugin~Plugin>} module:common/classes/app~App#plugins
     */
    this.plugins = new Set();
    /**
     * @member {Map<module:common/classes/component~Component>}
     */
    this.components = new Map();
    /**
     * @member {Map<module:common/classes/filter~Filter>}
     */
    this.filters = new Map();
  }

  /**
   * @method
   * @param {module:common/classes/plugin~Plugin} plugin - Плагин для регистрации
   * @description Зарегистрировать плагин
   */
  usePlugin(plugin) {
    const mutable = plugin;
    mutable.config.app = this;
    this.plugins.add(mutable);
  }

  /**
   * @method
   * @param {String} name - Имя фильтра
   * @param {module:common/classes/filter~Filter} filter - Фильтр для регистрации
   */
  useFilter(name, filter) {
    this.filters.set(name, filter);
  }

  /**
   * @method
   * @param {String} name - Имя компоненты, которое будет использоваться при связке
   * @param {module:common/classes/component~Component} component - Компонент для регистрации
   * @description Зарегистрировать компоненту
   */
  registerComponent(name, component) {
    this.components.set(name, component);
  }

  /**
   * @method
   * @description Производит инициализацию плагинов и связку компонент внутри приложения
   */
  init() {
    const elements = [...document.querySelectorAll('[data-component]')];
    elements.forEach((element) => {
      const { component: componentName } = element.dataset;
      const ComponentClass = this.components.get(componentName);
      if (!ComponentClass) {
        console.warn(`Компонент с именем ${componentName} не зарегистрирован!`);
        return;
      }
      const component = new ComponentClass(element);
      console.log(componentName, 'зарегистрирован');
    });
    this.plugins.forEach((plugin) => {
      plugin.init();
    });
  }
}

export default App;
